import { render } from "./PhoneField.vue?vue&type=template&id=fe8be75c&ts=true"
import script from "./PhoneField.vue?vue&type=script&lang=ts"
export * from "./PhoneField.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__